import { AdditionalInformation } from '@hivebrite/design-system/AdditionalInformation';
import { Box } from '@hivebrite/design-system/Box';

const getError = (errors) => {
  if (typeof errors === 'object' && errors !== null) {
    return Object.values(errors).join(', ');
  }

  if (Array.isArray(errors)) {
    return errors.join(', ');
  }

  return errors.toString();
};

export const Errors = ({ id = 'payment-error', errors }) => {
  if (!errors) {
    return null;
  }

  return (
    <Box mb={3}>
      <AdditionalInformation id={id} mt={0}>
        {getError(errors)}
      </AdditionalInformation>
    </Box>
  );
};
